import { ActionTypes } from '../../constants/ActionTypes';
import { IDashboardState } from '../../interfaces';

const INIT_STATE: IDashboardState = {
  recentNews: [],
  automationStatistics: {
    action: [],
    draft: [],
    inboxUnreadCount: 0,
    notifyCount: 0,
  },
  recentNewsLoading: false,
};

/*
let t = {
  action: [{ code: "Follow-0", count: 0, unreadCount: 0 }, { code: "Action-0", count: 0, unreadCount: 0 }],
  draft: [{ code: "Draft-0", count: 0, unreadCount: 0 }],
  unreadCount: 0,
  inboxUnreadCount: 0,
  notifyCount: 0,
}
*/
export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_RECENT_NEWS_SUCCESS: {
      return {
        ...state,
        recentNews: action.payload,
        recentNewsLoading: false,
      };
    }

    case ActionTypes.GET_RECENT_NEWS: {
      return {
        ...state,
        recentNews: [],
        recentNewsLoading: true,
      };
    }

    case ActionTypes.FETCH_AUTOMATION_STATISTICS_SUCCESS:
      return {
        ...state,
        automationStatistics: action.payload,
        automationStatisticsLoading: false,
      };

    case ActionTypes.GET_AUTOMATION_STATISTICS:
      return {
        ...state,
        automationStatistics: {
          action: [],
          draft: [],
          inboxUnreadCount: 0,
          notifyCount: 0,
        },
        automationStatisticsLoading: false,
      };
    default:
      return state;
  }
};
